export default __webpack_public_path__ + "static/media/fi-rs-phone-call.7560663f.svg";